<ng-container *ngIf="loaded">
  <ng-template [ngIf]="checked" [ngIfElse]="notChecked">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      class="imported"
    >
      <g clip-path="url(#clip0_833_32836)">
        <rect width="20" height="20" rx="10" fill="#2DBBFC" />
        <path
          d="M8.176 12.7269L6.20699 10.7578C5.98479 10.5356 5.62453 10.5356 5.40233 10.7578C5.18013 10.98 5.18013 11.3403 5.40233 11.5625L8.1602 14.3204C8.16893 14.3291 8.18308 14.3291 8.1918 14.3204L14.5977 7.91451C14.8199 7.69231 14.8199 7.33205 14.5977 7.10985C14.3755 6.88765 14.0152 6.88765 13.793 7.10985L8.176 12.7269Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_833_32836">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>

  <ng-template #notChecked>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <circle
        cx="10.4902"
        cy="10.9429"
        r="9.25"
        stroke="black"
        stroke-opacity="0.14"
        stroke-width="1.5"
      />
    </svg>
  </ng-template>
</ng-container>
